module.exports = __webpack_public_path__ + "img/img_tutorial_06.fb206e1c.svg";